import { render } from "./WebDev.vue?vue&type=template&id=123f3594"
import script from "./WebDev.vue?vue&type=script&lang=js"
export * from "./WebDev.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__